exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-bg[data-v-0f053621]{background-position:100% 100%;background-repeat:no-repeat;background-size:100% 100%}.metal-number[data-v-0f053621]{font-family:Ysbth;background-image:-webkit-gradient(linear,left bottom,left top,from(#24b5c9),to(#c4eded));background-image:linear-gradient(0deg,#24b5c9,#c4eded);background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent}", ""]);

// exports
